import { BaseDialog } from '@internal/plugin-components-react';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import {
  Typography,
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import {


  EnvVarKind,
} from '../../api/types';
import { FormTextInput } from '@internal/plugin-components-react/src/common/FormTextInput';
import AutoComplete from '@internal/plugin-components-react/src/common/AutoComplete';

const initialEnvVarRequestItem = {
  serviceName: '',
  variableName: '',
  variableValue: '',
  kind: 'configmap',
};

export const AddEnvVarDialog = ({
  environmentVariables,
  serviceNames,
  onCancel,
  onSubmit,
}






) => {
  const formik = useFormik({
    initialTouched: {
      serviceName: false,
      variableName: false,
      variableValue: false,
    },
    initialValues: initialEnvVarRequestItem,
    onSubmit: values => {
      onSubmit([
        ...environmentVariables,
        {
          environmentVariableId: -1,
          ...values,
        },
      ]);
    },
  });
  useEffect(() => {
    formik.registerField('variableName', {
      validate: (variableName) => {
        if (!variableName) return 'Required';
        return environmentVariables.find(
          envVar =>
            envVar.serviceName === formik.values.serviceName &&
            envVar.variableName === variableName,
        )
          ? 'Variable name already exists in the selected service'
          : undefined;
      },
    });
    return () => {
      formik.unregisterField('variableName');
    };
  });
  useEffect(() => {
    formik.registerField('serviceName', {
      validate: (serviceName) =>
        !serviceName ? 'Required' : undefined,
    });
    return () => {
      formik.unregisterField('serviceName');
    };
  });
  useEffect(() => {
    formik.registerField('variableValue', {
      validate: (variableValue) =>
        !variableValue ? 'Required' : undefined,
    });
    return () => {
      formik.unregisterField('variableValue');
    };
  });

  return (
    React.createElement(BaseDialog, {
      isOpen: true,
      title: "Add Variable" ,
      btnSubmitDisabled: 
        !Object.values(formik.touched).every(Boolean) ||
        Object.values(formik.errors).some(Boolean)
      ,
      handleSubmit: formik.handleSubmit,
      handleClose: onCancel,
      btnCloseText: "Cancel",
      btnSubmitText: "Save",}
    
      , React.createElement(Box, {
        display: "flex",
        flexDirection: "column",
        style: { gap: '1rem' },
        component: "form",
        id: "add-edit-form",}
      
        , React.createElement(AutoComplete, {
          optionLabelField: ['serviceName'],
          list: serviceNames.map(serviceName => ({ serviceName })),
          onChange: (service) => {
            formik.setFieldTouched('serviceName', true);
            formik.setFieldValue('serviceName', service?.serviceName || null);
          },
          inputLabel: "Select Service" ,
          label: "Service Name" ,
          value: { serviceName: formik.values.serviceName || '' },}
        )
        , React.createElement(FormTextInput, {
          id: "variableName",
          name: "variableName",
          label: "Key",
          value: formik.values.variableName,
          error: formik.touched.variableName && !!formik.errors.variableName,
          helperText: formik.touched.variableName && formik.errors.variableName,
          onChange: (event) => {
            formik.setFieldTouched('variableName', true);
            formik.setFieldValue('variableName', event.target.value);
          },}
        )
        , React.createElement(FormTextInput, {
          id: "variableValue",
          name: "variableValue",
          label: "Value",
          value: formik.values.variableValue,
          error: formik.touched.variableValue && !!formik.errors.variableValue,
          helperText: 
            formik.touched.variableValue && formik.errors.variableValue
          ,
          onChange: (event) => {
            formik.setFieldTouched('variableValue', true);
            formik.setFieldValue('variableValue', event.target.value);
          },}
        )
        , React.createElement(FormControl, null
          , React.createElement(FormLabel, { id: "kind",}
            , React.createElement(Typography, {
              variant: "body1",
              style: { fontWeight: 'bold' },
              color: "textPrimary",
              role: "title",}
            , "Kind"

            )
          )
          , React.createElement(RadioGroup, {
            'aria-labelledby': "kind",
            defaultValue: formik.initialValues.kind,
            name: "kind",
            value: formik.values.kind,
            onChange: formik.handleChange,}
          
            , [EnvVarKind.enum.configmap, EnvVarKind.enum.secret].map(opt => (
              React.createElement(FormControlLabel, {
                value: opt,
                control: 
                  React.createElement(Radio, {
                    disableRipple: true,
                    color: opt === formik.values.kind ? 'primary' : 'default',}
                  )
                ,
                label: React.createElement(Typography, { color: "textPrimary",}, opt),}
              )
            ))
          )
        )
      )
    )
  );
};

export const EditEnvVarDialog = ({
  environmentVariables,
  environmentVariableId,
  onCancel,
  onSubmit,
}






) => {
  const initialEnvVar = environmentVariables.find(
    envVar => envVar.environmentVariableId === environmentVariableId,
  ) ;
  const [currentEnvVar, setCurrentEnvVar] = useState(initialEnvVar);
  return (
    React.createElement(BaseDialog, {
      isOpen: true,
      title: "Edit Variable" ,
      handleSubmit: () => {
        environmentVariables.forEach(envVar => {
          if (envVar.environmentVariableId === environmentVariableId) {
            envVar.variableValue = currentEnvVar.variableValue;
          }
        });
        onSubmit(environmentVariables);
      },
      handleClose: onCancel,
      btnCloseText: "Cancel",
      btnSubmitText: "Save",}
    
      , React.createElement(Box, {
        display: "flex",
        flexDirection: "column",
        style: { gap: '1rem' },
        component: "form",
        id: "add-edit-form",}
      
        , React.createElement(FormTextInput, {
          id: "serviceName",
          name: "serviceName",
          label: "Service Name" ,
          value: currentEnvVar.serviceName,
          disabled: true,}
        )
        , React.createElement(FormTextInput, {
          id: "env-var-key",
          name: "env-var-key",
          label: "Key",
          value: currentEnvVar.variableName,
          disabled: true,}
        )
        , React.createElement(FormTextInput, {
          id: "env-var-value",
          name: "env-var-value",
          label: "Value",
          value: currentEnvVar.variableValue,
          onChange: (event) => {
            setCurrentEnvVar({
              ...currentEnvVar,
              variableValue: event.target.value,
            });
          },}
        )
      )
    )
  );
};

export const RemoveEnvVarDialog = ({
  environmentVariables,
  environmentVariableId,
  onCancel,
  onSubmit,
}






) => {
  const targetEnvVar = environmentVariables.find(
    envVar => envVar.environmentVariableId === environmentVariableId,
  ) ;
  return (
    React.createElement(BaseDialog, {
      isOpen: true,
      title: "Remove Variable" ,
      handleSubmit: () => {
        const targetIndex = environmentVariables.findIndex(
          envVar => envVar.environmentVariableId === environmentVariableId,
        );
        environmentVariables.splice(targetIndex, 1);
        onSubmit(environmentVariables);
      },
      handleClose: onCancel,
      btnCloseText: "Cancel",
      btnSubmitText: "Remove",}
    , "Are you sure you want to remove"
            , ' '
      , React.createElement('strong', null, targetEnvVar.variableName), "?"
    )
  );
};
